/**
 * Turn a brand-owned image value into a source the browser may render as an
 * image. Logos and browser icons share this URI decision.
 */
export function brandImageSrc(
  value: string | null | undefined,
  options: { allowRemote?: boolean; maxLength?: number } = {},
): string | null {
  const v = value?.trim()
  if (!v) return null
  if (options.maxLength !== undefined && v.length > options.maxLength) return null
  if (v.startsWith('<')) return `data:image/svg+xml,${encodeURIComponent(v)}`
  if (/^data:image\/(svg\+xml|png|jpeg|gif|webp|x-icon|vnd\.microsoft\.icon)[;,]/i.test(v)) return v
  if (options.allowRemote !== false && /^https?:\/\//i.test(v)) return v
  return null
}

/** Favicons are document-level requests: do not turn an arbitrary remote URL
 * into a tracking/CSP escape hatch. Settings upload an inert data image. */
export function faviconSrc(value: string | null | undefined): string | null {
  return brandImageSrc(value, { allowRemote: false, maxLength: 256 * 1024 })
}
